import api from "../../../../../../services/api";

// Busca em lote a disponibilidade (SNMP/PING) de hosts Zabbix vinculados a nodes do diagrama
export const fetchHostsStatus = async (hostIds = []) => {
  if (!hostIds?.length) return {};
  const response = await api?.post?.("/interno/zabbix/getHostsStatus", {
    hostIds,
  });
  return response?.data || {};
};
